<ul class="nav flex-column">
  <!-- Section -->
  @for (section of msfps.allSections; track section; let i = $index) {
    <li
      class="nav-item p-2"
      [class.d-none]="section.ParentID"
      [ngClass]="
        msfps.activeSecInfo?.UniqueID === section?.UniqueID
          ? 'bg-secondary-custom-subtler border'
          : ''
      "
    >
      <div class="d-flex align-items-center justify-content-start">
        @if (
          msfps.isSectionOptional(section.UniqueID) ||
          msfps.isSectionStatic(section.UniqueID)
        ) {
        } @else {
          <i
            class="cursor-pointer fa-solid"
            (click)="
              msfps.previewSection(section);
              msfps.toggleChildrenContent(section.UniqueID)
            "
            [ngClass]="
              msfps.isSectionContentCollapsed(section.UniqueID)
                ? 'fa-angle-right'
                : 'fa-angle-down'
            "
          ></i>
        }
        <a
          class="nav-link"
          [ngClass]="
            msfps.activeSecInfo?.UniqueID === section?.UniqueID
              ? 'text-primary fw-bold'
              : ''
          "
          (click)="msfps.previewSection(section)"
          >{{ section.Title }}</a
        >
      </div>
      <!-- SubSections List -->
      @if (section?.Sections?.length) {
        @if (msfps.activeSecInfo?.UniqueID === section?.UniqueID) {
          <ul class="nav flex-column ms-2">
            @for (
              section of msfps.getActiveSecFieldsSegregatedintoSections()
                | keyvalue: asIsOrder;
              track section
            ) {
              @if (
                !msfps.getSegregatedSection(section.key)
                  .isParentSectionCollapsed
              ) {
                <li
                  class="nav-item p-2"
                  [ngClass]="
                    msfps.getSegregatedSection(section.key)
                      .isEntireSectionBeingPreviewed
                      ? 'bg-secondary-custom-subtle border'
                      : ''
                  "
                >
                  <div class="d-flex align-items-center justify-content-start">
                    @if (!msfps.isSectionStatic(section.key)) {
                      <i
                        class="cursor-pointer fa-solid"
                        [ngClass]="
                          msfps.isSectionContentCollapsed(section.key)
                            ? 'fa-angle-right'
                            : 'fa-angle-down'
                        "
                        (click)="msfps.toggleChildrenContent(section.key)"
                      ></i>
                    }
                    <a
                      class="nav-link"
                      [ngClass]="
                        msfps.getSegregatedSection(section.key)
                          .isEntireSectionBeingPreviewed
                          ? 'text-primary fw-medium'
                          : ''
                      "
                      (click)="msfps.showEntireSectionPreview(section.key)
                      "
                      >{{ msfps.getSection(section.key).Title }}</a
                    >
                  </div>
                  <!-- SubSection Fields -->
                  @if (
                    !msfps.getSegregatedSection(section.key)
                      .areSectionFieldsCollapsed
                  ) {
                    @for (
                      sectionField of section.value.fieldsList;
                      track sectionField
                    ) {
                      <ul class="nav flex-column ps-2 ms-4">
                        @if (
                          (sectionField.isQnFieldVisibleOnNavListItems &&
                            !sectionField.isQnFieldOptional) ||
                          (msfps.doesHiddenInputExistFor(sectionField) &&
                            section.value.sectionDetails.Title !==
                              sectionField.data[0].dispalyFCText)
                        ) {
                          <li class="nav-item">
                            <div
                              class="d-flex align-items-center justify-content-start"
                            >
                              <div
                                class="d-flex align-items-center justify-content-start"
                              >
                                @if (
                                  !msfps.doesHiddenInputExistFor(sectionField)
                                ) {
                                  <i
                                    [class]="
                                      (
                                        ''
                                        | legend
                                          : sectionField?.answered
                                          : sectionField?.valid
                                          : sectionField?.data[1]
                                              ?.isDisableInputChecked
                                      ).faIconClass
                                    "
                                    [title]="
                                      (
                                        ''
                                        | legend
                                          : sectionField?.answered
                                          : sectionField?.valid
                                          : sectionField?.data[1]
                                              ?.isDisableInputChecked
                                      ).tooltip
                                    "
                                  ></i>
                                  <span
                                    class="py-2 cursor-pointer"
                                    [ngClass]="
                                      msfps.toggleIndividualSectionFieldPreviewMode &&
                                      sectionField.isFieldBeingPreviewedIndividually
                                        ? 'text-primary fw-bold'
                                        : ''
                                    "
                                    (click)="preview(sectionField)"
                                    >{{
                                      sectionField.data[0].dispalyFCText
                                    }}</span
                                  >
                                }
                                <!--
                                @if (
                                  msfps.toggleIndividualSectionFieldPreviewMode
                                ) {
                                  <i
                                    class="cursor-pointer fa ms-1 text-dark"
                                    [ngClass]="
                                      sectionField.isFieldBeingPreviewedIndividually
                                        ? 'fa-eye-slash'
                                        : 'fa-eye'
                                    "
                                    (click)="
                                      sectionField.isFieldBeingPreviewedIndividually
                                        ? msfps.hideSectionFieldPreview(
                                            sectionField
                                          )
                                        : msfps.showSectionFieldPreview(
                                            sectionField
                                          )
                                    "
                                  ></i>
                                }
                                -->
                              </div>
                            </div>
                          </li>
                        }
                      </ul>
                    }
                  }
                </li>
              }
            }
          </ul>
        }
      } @else {
        <!-- Section Fields -->
        @if (
          msfps.activeSecInfo?.UniqueID === section?.UniqueID &&
          !msfps.getSegregatedSection(section.UniqueID)
            ?.areSectionFieldsCollapsed
        ) {
          @for (
            sectionField of msfps.getSegregatedSection(section.UniqueID)
              .fieldsList;
            track sectionField
          ) {
            <ul class="nav flex-column ps-2 ms-4">
              @if (
                (sectionField.isQnFieldVisibleOnNavListItems &&
                  !sectionField.isQnFieldOptional) ||
                (msfps.doesHiddenInputExistFor(sectionField) &&
                  section.Title !== sectionField.data[0].dispalyFCText)
              ) {
                <li class="nav-item">
                  <div class="d-flex align-items-center justify-content-start">
                    <div
                      class="d-flex align-items-center justify-content-start"
                    >
                      @if (!msfps.doesHiddenInputExistFor(sectionField)) {
                        <i
                          [class]="
                            (
                              ''
                              | legend
                                : sectionField?.answered
                                : sectionField?.valid
                                : sectionField?.data[1]?.isDisableInputChecked
                            ).faIconClass
                          "
                          [title]="
                            (
                              ''
                              | legend
                                : sectionField?.answered
                                : sectionField?.valid
                                : sectionField?.data[1]?.isDisableInputChecked
                            ).tooltip
                          "
                        ></i>
                      }
                      <span
                        class="py-2 cursor-pointer"
                        [ngClass]="
                          msfps.toggleIndividualSectionFieldPreviewMode &&
                          sectionField.isFieldBeingPreviewedIndividually
                            ? 'text-primary fw-bold'
                            : ''
                        "
                        (click)="preview(sectionField)"
                        >{{ sectionField.data[0].dispalyFCText }}</span
                      >
                      <!--
                      @if (msfps.toggleIndividualSectionFieldPreviewMode) {
                        <i
                          class="cursor-pointer fa ms-1 text-dark"
                          [ngClass]="
                            sectionField.isFieldBeingPreviewedIndividually
                              ? 'fa-eye-slash'
                              : 'fa-eye'
                          "
                          (click)="
                            sectionField.isFieldBeingPreviewedIndividually
                              ? msfps.hideSectionFieldPreview(sectionField)
                              : msfps.showSectionFieldPreview(sectionField)
                          "
                        ></i>
                      }
                      -->
                    </div>
                  </div>
                </li>
              }
            </ul>
          }
        }
      }
    </li>
  }
</ul>
